import {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {getFile, postFile} from '../../../../../../services/files'
import {useToast} from '../../../../../components/Toats'
import {LoadingSpan} from '../../../../../components/Loadings/loadingSpan'
import styles from '../../modalClient.module.css'

type Props = {
  imageKey?: string | null
  name?: string | null
  onChange: (key: string | null) => void
}

const getInitials = (name?: string | null) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return ''
  const first = parts[0][0]
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return `${first}${last}`.toUpperCase()
}

const ClientAvatarUpload: FC<Props> = ({imageKey, name, onChange}) => {
  const {toggleToast} = useToast()
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let active = true

    const loadPreview = async () => {
      if (!imageKey) {
        if (active) setPreviewUrl(null)
        return
      }
      try {
        const response = await getFile(imageKey)
        if (active) setPreviewUrl(response?.url || null)
      } catch {
        if (active) setPreviewUrl(null)
      }
    }

    loadPreview()
    return () => {
      active = false
    }
  }, [imageKey])

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    try {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', file)
      const uploaded = await postFile(formData)
      onChange(uploaded?.key || null)
      if (uploaded?.url) setPreviewUrl(uploaded.url)
      toggleToast('Foto enviada com sucesso.', 'success')
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao enviar a foto.', 'error')
    } finally {
      setLoading(false)
      event.target.value = ''
    }
  }

  const initials = getInitials(name)

  return (
    <div className={styles.avatarBox}>
      <div className={styles.avatar}>
        {previewUrl ? (
          <img src={previewUrl} alt='Foto do cliente' />
        ) : (
          <span className={styles.avatarInitials}>
            {initials || (
              <KTSVG
                path='/media/icons/duotune/communication/com006.svg'
                className='svg-icon-2hx svg-icon-primary'
              />
            )}
          </span>
        )}

        <label
          className={`${styles.avatarOverlay} ${loading ? styles.avatarLoading : ''}`}
          title={previewUrl ? 'Trocar foto' : 'Adicionar foto'}
        >
          {loading ? (
            <LoadingSpan />
          ) : (
            <>
              <i className='bi bi-camera fs-3 text-white'></i>
              {previewUrl ? 'Trocar' : 'Adicionar'}
            </>
          )}
          <input type='file' accept='image/*' hidden disabled={loading} onChange={handleUpload} />
        </label>
      </div>

      <div className={styles.avatarActions}>
        {imageKey ? (
          <button
            type='button'
            className={`${styles.linkButton} ${styles.linkButtonDanger}`}
            disabled={loading}
            onClick={() => {
              onChange(null)
              setPreviewUrl(null)
            }}
          >
            Remover foto
          </button>
        ) : (
          <span className='text-muted'>JPG, PNG ou WEBP</span>
        )}
      </div>
    </div>
  )
}

export {ClientAvatarUpload}
